import React from 'react';
import BasicHighchartGraph from '../../Graph/BasicHighchartGraph';
import OnboardingDashboardCard from './OnboardingDashboardCard';

function getChartItem(dataArray, name, color) {
    return {
        name,
        data: dataArray,
        color,
        dashStyle: 'solid',
        type: 'line',
        opacity: 1,
        marker: { enabledThreshold: 0 }
    };
}

function TotalCustomersListCard(props) {
    const { customerCount, feedbackData } = props;
    const safeFeedbackData = Array.isArray(feedbackData) ? feedbackData : [];
    
    const feedbackByDate = {};
    safeFeedbackData.forEach(item => {
        const date = item.createdAt.slice(0, 10); 
        if (!feedbackByDate[date]) feedbackByDate[date] = 0;
        feedbackByDate[date] += 1;
    });
    
    const sortedDates = Object.keys(feedbackByDate).sort();
    const valueArr = sortedDates.map(date => ({
        x: new Date(date).getTime(),
        y: feedbackByDate[date]
    }));

    const hasData = valueArr.length > 0;
    const chartData = [getChartItem(valueArr, 'Cancelled Subscriptions', '#8884d8')];

    const content = hasData ? (
        <div className="row no-gutters card-row margin-8-0 text-center">
            <div className="col min-height-60">
                <div className="onboarding-table margin-0-20"  style={{ minHeight: 400 }}>
                    <BasicHighchartGraph
                        chartData={chartData}
                        yAxisTitle="Count"
                        legend={{ enabled: true }}
                        height={400}
                    />
                </div>
            </div>
        </div>
    ) : (
        <div className="text-center">No Cancelled Subscriptions data available</div>
    );

    return (
        <div>
            <OnboardingDashboardCard title="Cancelled Subscriptions" content={content} isGraphCard={false}  />
        </div>
    );
}

export default TotalCustomersListCard;